export default {
  name: 'Conférence de Paris',
  shortName: 'Paris',
  description:
    'Lancée en 2017, la Conférence de Paris rassemble des décideurs du monde des affaires, des gouvernements et de la société civile afin de promouvoir l’échange d’idées et de perspectives autour des grands enjeux actuels.',
  thumbnail: '/images/events/paris/thumbnail-paris.jpg',
  link: 'https://www.conferencedeparis.com/',
  header: {
    content:
      'Lancée en 2017, la Conférence de Paris rassemble des décideurs du monde des affaires, des gouvernements et de la société civile afin de promouvoir l’échange d’idées et de perspectives autour des grands enjeux actuels.'
  },
  bullets: {
    bullet1: {
      number: '13ème',
      label: 'Édition'
    },
    bullet2: {
      number: '1 400+',
      label: 'Participants'
    },
    bullet3: {
      number: '70+',
      label: 'Conférenciers'
    },
    bullet4: {
      number: '75+',
      label: 'Pays Représentés'
    }
  },
  about: {
    title: 'Notre objectif',
    content:
      'Cet événement de plusieurs jours encourage les dirigeants à partager leurs connaissances et leur compréhension des questions économiques, sociales et environnementales mondiales afin de collaborer et de relever collectivement ces défis. Principal événement européen annuel du FEIA, la Conférence de Paris vise à favoriser le commerce international entre l’Europe et les Amériques, tout en encourageant des relations mondiales plus vastes qui mèneraient à des changements positifs.'
  },
  next: {
    title: 'Bridging The Divide',
    content:
      "L'édition de cette année réunira des dirigeants internationaux pour se concerter et redéfinir l'ordre mondial actuel et développer de nouveaux objectifs en termes de commerce et d'investissement. La conférence, qui se tiendra à l'OCDE à Paris les 28 et 29 novembre 2023, comprendra des panels de discussion, ainsi que diverses opportunités de réseautage, telles que des déjeuners et des réceptions, afin d'encourager la mise en relation et la collaboration entre les participants."
  },
  gallery: {
    title: 'Galerie de photos',
    index: [
      {
        title: '12ème édition',
        images: [
          '/images/events/paris/gallery/12th-paris-001.jpg',
          '/images/events/paris/gallery/12th-paris-002.jpg',
          '/images/events/paris/gallery/12th-paris-003.jpg',
          '/images/events/paris/gallery/12th-paris-004.jpg',
          '/images/events/paris/gallery/12th-paris-005.jpg',
          '/images/events/paris/gallery/12th-paris-006.jpg',
          '/images/events/paris/gallery/12th-paris-007.jpg',
          '/images/events/paris/gallery/12th-paris-008.jpg',
          '/images/events/paris/gallery/12th-paris-009.jpg'
        ]
      }
    ]
  },
  board: {
    uptitle: 'À propos',
    title: 'Bureau des gouverneurs et Comité aviseur',
    content:
      "Les membres de la direction de la Conférence de Paris travaillent en étroite collaboration avec un groupe d'individus rigoureusement sélectionnés qui forment notre bureau des gouverneurs et notre comité aviseur. Tous les membres ont été soigneusement désignés pour leurs connaissances approfondies et leur expérience dans leurs domaines respectifs.",
    buttonGovernors: 'Bureau des gouverneurs',
    buttonAdvisory: 'Comité aviseur'
  },
  governorsIndex: {
    title: 'Bureau des gouverneurs',
    chairmens: {
      title: 'Coprésidents',
      index: [
        {
          name: 'Paul Desmarais Jr.',
          info: 'Président, Power Corporation of Canada (PCC)',
          image: '/images/boards/paris/paul_desmarais_jr.png'
        },
        {
          name: 'Jean-Pierre Clamadieu',
          info: 'Président, ENGIE',
          image: '/images/boards/paris/Clamadieu-Jean-Pierre.jpg'
        }
      ]
    },
    members: {
      title: 'Gouverneurs',
      index: [
        {
          name: 'Gil Rémillard ',
          info: 'Président-fondateur, Forum économique international des Amériques (FEIA)',
          image: '/images/boards/paris/Gil_Remillard.jpg'
        },
        {
          name: 'Darius Adamczyk',
          info: 'Président-directeur général, Honeywell',
          image: '/images/boards/paris/Darius-Adamczyk.jpg'
        },
        {
          name: 'Jean-Paul Agon',
          info: "Président, L'Oréal",
          image: '/images/boards/paris/Agon-Jean-Paul.jpg'
        },
        {
          name: 'Hélène Desmarais',
          info: 'Présidente exécutive, IVADO and Chair of the Board HEC Montréal',
          image: '/images/boards/paris/desmarais-helene.jpg'
        },
        {
          name: 'Kristina M. Johnson',
          info: 'Présidente, The Ohio State University',
          image: '/images/boards/paris/Johnson-Kristina.jpg'
        },
        {
          name: 'Jean Lemierre',
          info: 'Président, BNP Paribas',
          image: '/images/boards/paris/Jean-Lemierre.jpg'
        },
        {
          name: 'Shunichi Miyanaga',
          info: 'Président, Mitsubishi Heavy Industries',
          image: '/images/boards/paris/Miyanaga-Shunichi.jpg'
        },
        {
          name: 'Laurence Parisot',
          info: 'Présidente, Citigroup',
          image: '/images/boards/paris/Parisot-Laurence.jpg'
        },
        {
          name: 'Muriel Pénicaud',
          info: 'Ambassadrice, Représentante permanente de la France auprès de l’OCDE',
          image: '/images/boards/paris/Penicaud-Muriel.jpg'
        },
        {
          name: 'Patrick Pouyanné',
          info: 'Président-directeur général, TotalEnergies',
          image: '/images/boards/paris/Pouyanne-Patrick.jpg'
        },
        {
          name: 'Ian Gallienne',
          info: 'Directeur général, GBL',
          image: '/images/boards/paris/Gallienne-Ian.jpg'
        },
        {
          name: 'Alain Fuchs',
          info: 'Président, PSL University',
          image: '/images/boards/paris/Fuchs-Alain.jpg'
        },
        {
          name: 'Mathias Cormann',
          info: 'Secrétaire général, Organisation de coopération et de développement économiques (OCDE)',
          image: '/images/boards/paris/Cormann-Mathias.jpg'
        },
        {
          name: 'James P. Gorman',
          info: 'Président-directeur général, Morgan Stanley',
          image: '/images/boards/paris/James-Gorman.jpg'
        },
        {
          name: 'Amélie de Montchalin',
          info: 'Représentante permanente de la France auprès de l’OCDE',
          image: '/images/boards/paris/amelie.jpg'
        }
      ]
    },
    secretaries: {
      title: 'Secrétaire',
      index: [
        {
          name: 'Bernard Spitz',
          info: 'Président du Pôle International et Europe, MEDEF',
          image: '/images/boards/paris/Spitz-Bernard.jpg'
        }
      ]
    }
  },
  advisoryIndex: {
    title: 'Comité aviseur',
    chairmen: {
      title: 'Présidente',
      index: [
        {
          name: 'Gwenaelle Avice-Huet',
          info: 'Directrice générale, Stratégie et Développement durable, Schneider Electric',
          image: '/images/boards/paris/Avice-Huet-Gwenaelle-cropped.jpg'
        }
      ]
    },
    members: {
      title: 'Membres',
      index: [
        {
          name: 'Nicolas Blain',
          info: 'Chef du Pôle Relations Internationales et Affaires européennes, Groupe RATP',
          image: '/images/boards/paris/blain-nicolas.png'
        },
        {
          name: 'Didier Le Bret',
          info: 'Diplomate et associé, ESL',
          image: '/images/boards/paris/Le-Bret-Didier.png'
        },
        {
          name: 'Eric Meyer',
          info: 'Directeur, France, RBC Marchés des Capitaux',
          image: '/images/boards/paris/meyer-eric.png'
        },
        {
          name: 'Dorothée Pineau',
          info: 'Conseillère du Président, Mouvement des entreprises de France (MEDEF)',
          image: '/images/team/DorothéePineau.jpg'
        },
        {
          name: 'Bertrand Richard',
          info: 'Conseiller principal, Spencer Stuart',
          image: '/images/boards/paris/richard.jpg'
        }
      ]
    }
  }
}
